import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';

function Login({ onLogin }) {
    const [searchParams] = useSearchParams();
    const emailFromUrl = (searchParams.get('email') || '').trim();
    const [email, setEmail] = useState(emailFromUrl);
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { t } = useTranslation();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}auth/signin`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
                credentials: 'include'
            });

            const data = await response.json();

            if (!response.ok) throw new Error(data.message || t('login.errorDefault'));

            {/*
            Cookies.set('idToken', data.idToken, { secure: true, httpOnly: true, expires: 1 });
            Cookies.set('accessToken', data.accessToken, { secure: true, httpOnly: true, expires: 1 });
            */}

            await clearBrowserCache();

            onLogin();
        } catch (err) {
            console.log("err", err);
            setError(err.message);
        }
    };

    async function clearBrowserCache() {
        try {
            //keep prefs that should survive login 
            const preserveKeys = ['i18nextLng'];
            const preserved = {};
            for (const key of preserveKeys) {
                try {
                    const value = localStorage.getItem(key);
                    if (value != null) preserved[key] = value;
                } catch (_) {
                }
            }

            localStorage.clear();
            sessionStorage.clear();

            for (const [key, value] of Object.entries(preserved)) {
                try {
                    localStorage.setItem(key, value);
                } catch (_) {
                }
            }

            // Cache Storage
            if ('caches' in window) {
                const cacheNames = await caches.keys();
                await Promise.all(
                    cacheNames.map(name => caches.delete(name))
                );
            }

        } catch (err) {
            console.error('Erro ao limpar cache:', err);
        }
    }
    

    return (
        <div className="login-container">
            <img src="/images/main_logo_horizontal_cinza.svg" alt="logo" />
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <form onSubmit={handleSubmit} className="login-form">
                <input
                    type="email"
                    placeholder={t('login.emailPlaceholder')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder={t('login.passwordPlaceholder')}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <div style={{ marginBottom: '1rem', textAlign: 'left' }}>
                    <Link to="/forgotPassword" style={{ color: 'red', fontSize: '0.9rem' }}>
                        {t('login.forgotPassword') || 'Esqueceste-te da tua palavra-passe?'}
                    </Link>
                </div>
                <button type="submit" disabled={!(email && password)}>{t('login.loginButton')}</button>
            </form>
        </div>
    );
}

export default Login;
